<template>
  <div id="page__site-renewal">
    <Header />

    <b-container id="content__site-renewal">
      <h2>Chegou a hora de renovar sua proteção</h2>

      <p>
        Para continuar protegendo o seu aparelho, faça a renovação do seu
        bilhete de seguro celular. <br />
        <strong
          >Atenção: saiba que é necessário que o aparelho seja o mesmo da
          contratação anterior.</strong
        >
      </p>

      <h3>Veja os benefícios de renovar agora:</h3>

      <div id="site-renewal__benefits-list">
        <BenefitsCard
          v-for="item in benefitsList"
          :key="item.title"
          :title="item.title"
          :description="item.description"
          :icon="item.icon"
        />
      </div>

      <h3>Informe o número do seu CPF para consulta</h3>

      <div id="site-renewal__doc">
        <cpf-input
          id="cpf"
          type="tel"
          v-model="cpf"
          :errorMessage="isCPFValid.message"
          :errorCondition="!isCPFValid.condition"
          :mask="'###.###.###-##'"
        />

        <button
          :disabled="!isFormValid || isLoading"
          @click.prevent.stop="fetchContracts(cpf)"
        >
          <img
            :src="require(`@/assets/svg/loader.svg`)"
            alt="Carregando..."
            v-if="isLoading"
          />
          <span v-else>Confirmar</span>
        </button>
      </div>

      <div
        v-if="contracts.length > 0"
        ref="contracts"
        id="site-renewal__contracts"
      >
        <h3>Selecione o dispositivo que deseja renovar</h3>
        <div class="site-renewal_contracts-list">
          <ContractCard
            v-for="contract in contracts"
            :key="contract.policyNumber"
            :info="contract"
            @openModal="handleModal($event)"
          />
        </div>
      </div>

      <p id="disclaimer__site-renewal">
        A Ciclic S.A. sob o CNPJ 29.032.677/0001-93,
        <a href="https://www.ciclic.com.br/">https://www.ciclic.com.br</a>, sob
        a inscrição na SUSEP 20.2020304-7, sede na Rua Alexandre Dumas, 1671 -
        3º Andar - Chácara Santo Antônio, São Paulo SP CEP:04717-004 é Corretora
        de Seguros da Assurant Seguradora S/A e está autorizada a comercializar
        o Seguro Celular Ciclic, Processo Susep Nº 15414.902134/2013-03.
        Restrições se aplicam. Consulte as Condições Gerais do Seguro antes de
        contratá-lo. O registro deste plano na SUSEP não implica, por parte da
        autarquia, incentivo ou recomendação à sua comercialização. Este seguro
        é garantido pela Assurant Seguradora S.A, sob o CNPJ 03.823.704/0001-52,
        sob sede na Alameda Rio Negro, 585, 3º andar, Bloco C, Alphaville,
        Barueri-SP, CEP: 06454-000, www.assurant.com.br, Inscrição Susep 0214-3.
        A CONTRATAÇÃO DO SEGURO É OPCIONAL SENDO POSSIVEL O CANCELAMENTO DO
        CONTRATO EM ATÉ 7 (SETE) DIAS CORRIDOS COM A DEVOLUÇÃO INTEGRAL DO VALOR
        PAGO. É proibido condicionar desconto no preço do bem à aquisição do
        seguro. A comercialização de seguro é fiscalizada pela SUSEP:
        www.susep.gov.br - 0800 021 8484. A Ciclic atua como intermediário do
        Programa de Seguros junto a Assurant Seguradora S.A. e, pela
        intermediação, recebe respectivamente o montante correspondente a
        porcentagem indicada, sobre o prêmio de seguro, de até 40%. O valor do
        prêmio total está somado a 7,38% de IOF. Os valores monetários finais do
        Prêmio Bruto, Prêmio Líquido e IOF estão descritos no bilhete de seguro,
        de acordo com a Resolução CNSP 285.
      </p>
    </b-container>

    <transition name="fade">
      <RenewalModal
        key="renewalModal"
        v-if="modal.active"
        :type="modal.type"
        @close="modal.active = false"
      />
    </transition>
  </div>
</template>

<script>
import Header from '@/components/Header/Header'
import BenefitsCard from './_components/BenefitsCard'
import CpfInput from './_components/CpfInput'
import ContractCard from './_components/ContractCard'
import RenewalModal from './_components/RenewalModal'

import cpfRule from '@/assets/validation/cpf.rule'
import { getActivePolicy } from '@/api/services'

export default {
  name: 'RenovacaoSite',
  components: {
    Header,
    BenefitsCard,
    CpfInput,
    ContractCard,
    RenewalModal
  },
  data () {
    return {
      cpf: '',
      isLoading: false,
      detailsModal: {
        active: false,
        contract: ''
      },
      modal: {
        active: false,
        type: 'renew'
      },
      benefitsList: [
        {
          title: 'Exclusivo para você',
          description: 'Cupom aplicado de  20%  no pagamento',
          icon: 'gift'
        },
        {
          title: 'Mais Facilidade',
          description: 'Renove dentro do prazo e não tenha carência',
          icon: 'protection'
        }
      ],
      contracts: [],
      noContracts: false
    }
  },
  computed: {
    isCPFValid () {
      let { message, condition } = cpfRule

      if (!this.cpf.length) {
        message = 'Informe o cpf'
      }
      return {
        message,
        condition: this.cpf.length === 11 && condition(this.cpf)
      }
    },
    isFormValid () {
      return this.cpf && this.isCPFValid.condition
    }
  },
  methods: {
    fetchContracts (cpf) {
      this.isLoading = true

      getActivePolicy(cpf)
        .then((response) => {
          if (!response.data || response.data.length === 0) {
            this.noContracts = true
            return
          }

          this.contracts = response.data.map((contract) => {
            const [brand, model] = contract.itemDto.name.split(' - ')

            return {
              brand,
              model,
              type: contract.itemDto.deviceTypeName,
              expirationDate: contract.expirationDate,
              policyNumber: contract.policyNumber,
              serialNumber: contract.serialNumber,
              imei: contract.imei,
              uuid: contract.uuid
            }
          })

          this.$refs.contracts.scrollIntoView({ behavior: 'smooth' })
        })
        .catch((err) => console.error(err))
        .finally(() => (this.isLoading = false))
    },
    handleModal (type) {
      this.modal = {
        type: type,
        active: true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#page__site-renewal {
  background-color: #f5f7fa;
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  #content__site-renewal {
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: flex-start;

    h2 {
      color: #444444;
      font-family: Oscine, sans-serif;
      font-size: 28px;
      font-style: normal;
      font-weight: 700;
      line-height: 35px;
      margin: 40px 0 24px;

      @media (min-width: 768px) {
        font-size: 32px;
        line-height: 40px;
      }
    }

    h3 {
      color: #444444;
      font-family: Oscine, sans-serif;
      font-size: 20px;
      font-style: normal;
      font-weight: bold;
      line-height: 25px;
      margin-top: 40px;

      @media (min-width: 768px) {
        font-size: 24px;
        line-height: 30px;
      }
    }

    p {
      color: #707070;
      font-family: Rubik, sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 21.6px;

      strong {
        font-weight: 700;
      }

      &#disclaimer__site-renewal {
        font-size: 10px;
        line-height: 13.5px;
        margin-top: auto;
        padding-top: 32px;
      }
    }

    #site-renewal__benefits-list {
      display: flex;
      flex-direction: column;
      margin-top: 24px;

      @media (min-width: 768px) {
        flex-direction: row;
      }
    }

    #site-renewal__doc {
      display: flex;
      flex-direction: column;
      margin-top: 22px;

      @media (min-width: 768px) {
        align-items: center;
        flex-direction: row;
      }

      button {
        background: #6320e9;
        border-radius: 28px;
        color: #ffffff;
        font-family: Oscine, sans-serif;
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        height: 40px;
        margin-top: 24px;
        max-width: 180px;
        padding: 8px 48px;
        width: 100%;

        @media (min-width: 768px) {
          margin-left: 16px;
          margin-top: 0;
        }

        &:disabled {
          opacity: 0.4;
        }

        img {
          height: 100%;
        }
      }
    }

    #site-renewal__contracts {
      overflow: auto;
      width: 100%;

      .site-renewal_contracts-list {
        display: grid;
        grid-column: center-start / -1;
        grid-template-columns: 240px 240px 240px 240px;
        grid-auto-flow: 2 column;
        gap: 1rem;
        overflow: auto;

        @media (min-width: 426px) {
          grid-template-columns: 1 1 272px 272px 272px 272px;
        }
      }
    }
  }

  .site-renewal_contracts-info {
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    margin: 15px 0 20px 10px;
  }

  h6 {
    margin-left: 10px;
    margin-right: 10px;
    height: 10px;
  }

  #site-renewal__tel {
    color: #6320e9;
    font-weight: bold;
    font-family: Rubik, sans-serif;
    margin-left: -5px;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
